import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight, Sparkles, Compass, Check, MapPin, Target, Radar, ShieldCheck, Tag, Heart, Package, AlertTriangle, Gift } from "lucide-react";
import { TYPEFORM , withUTM } from "../data/landing";
const T = Object.fromEntries(Object.entries(TYPEFORM).map(([k, v]) => [k, withUTM(v, "for-fans")]));
import AppStoreBadges from "../components/AppStoreBadges";

const A = {
  heroPhone: "https://customer-assets.emergentagent.com/job_toon-threads-3d/artifacts/jaq4yjo1_iPhone%2014%20Pro-2.png",
  giftCardGarfield: "https://customer-assets.emergentagent.com/job_toon-threads-3d/artifacts/yl1g8vdo_22_2x.png",
  giftCardAngel: "https://customer-assets.emergentagent.com/job_toon-threads-3d/artifacts/k3w2c5pp_Gift%20Card_2x-2.png",
  giftCardOhGeez: "https://customer-assets.emergentagent.com/job_toon-threads-3d/artifacts/pakrtgli_23_2x.png",
  egiftLogo: "https://customer-assets.emergentagent.com/job_toon-threads-3d/artifacts/6h0myuy8_eGift%20Logo.png",
  gemDiamond: "https://customer-assets.emergentagent.com/job_toon-threads-3d/artifacts/w3gmwybp_Gems.png",
  voiceRipple: "https://customer-assets.emergentagent.com/job_toon-threads-3d/artifacts/tx86kqt5_egeez%20ripple%20effect.png",
  cannotShip: "https://customer-assets.emergentagent.com/job_toon-threads-3d/artifacts/dzwk3apu_image.png",
  adventuresOfficialLogo: "https://customer-assets.emergentagent.com/job_toon-threads-3d/artifacts/zsus0ore_Group%2021.png",
  sortingHat: "https://customer-assets.emergentagent.com/job_toon-threads-3d/artifacts/dbz80068_Kai.png",
  voicePhone: "https://customer-assets.emergentagent.com/job_toon-threads-3d/artifacts/0zah2x2y_image.png",
  gem1: "https://customer-assets.emergentagent.com/job_toon-threads-3d/artifacts/laofq197_eGeez%20verified%20-%20gold-%20circle.png",
  gem2: "https://customer-assets.emergentagent.com/job_toon-threads-3d/artifacts/laofq197_eGeez%20verified%20-%20gold-%20circle.png",
  gem3: "https://customer-assets.emergentagent.com/job_toon-threads-3d/artifacts/laofq197_eGeez%20verified%20-%20gold-%20circle.png",
  gem4: "https://customer-assets.emergentagent.com/job_toon-threads-3d/artifacts/laofq197_eGeez%20verified%20-%20gold-%20circle.png",
  adventuresLogo: "https://customer-assets.emergentagent.com/job_toon-threads-3d/artifacts/gs9xwyp4_Premimere%20Drop%20logo.png",
  strangerPhone: "https://customer-assets.emergentagent.com/job_toon-threads-3d/artifacts/jaq4yjo1_iPhone%2014%20Pro-2.png",
  ticketPhone: "https://customer-assets.emergentagent.com/job_toon-threads-3d/artifacts/jaq4yjo1_iPhone%2014%20Pro-2.png",
  geoPhone: "https://customer-assets.emergentagent.com/job_toon-threads-3d/artifacts/dzwk3apu_image.png",
  cartoonCat: "https://customer-assets.emergentagent.com/job_toon-threads-3d/artifacts/nb5d389y_OhGeez_Colored.png",
  blueCheck: "https://customer-assets.emergentagent.com/job_toon-threads-3d/artifacts/r1enka3v_I%20am%20egeez%20verified-gold-%20post.png",
  // User-uploaded brand backgrounds
  bgBlue: "https://customer-assets.emergentagent.com/job_toon-threads-3d/artifacts/bvyosrzq_BG1.png",
  bgLightBlue: "https://customer-assets.emergentagent.com/job_toon-threads-3d/artifacts/4lkxeo9g_BG2.png",
  bgPink: "https://customer-assets.emergentagent.com/job_toon-threads-3d/artifacts/raqsjlz5_BG3.png",
  bgOrange: "https://customer-assets.emergentagent.com/job_toon-threads-3d/artifacts/pphq1t1h_BG4.png",
  stickers: "https://customer-assets.emergentagent.com/job_toon-threads-3d/artifacts/86ytbuuv_2023-07-29_00-49-02.png",
  // OhGeez blue logo (replacement for yellow sticker)
  ohGeezLogo: "https://customer-assets.emergentagent.com/job_toon-threads-3d/artifacts/nb5d389y_OhGeez_Colored.png",
  // Founder photos
  founderJimDavis: "https://customer-assets.emergentagent.com/job_toon-threads-3d/artifacts/ggtu75o8_January_16_2020_Nathen_Mazri_Garfield0210.webp",
  founderMascot: "https://customer-assets.emergentagent.com/job_toon-threads-3d/artifacts/93g9xnw2_1_782CxdQlYpe5xY_Tcs7kvg.jpg",
  founderGarfield: "https://customer-assets.emergentagent.com/job_toon-threads-3d/artifacts/pa2pv7p7_file1%20%281%29.jpeg",
  // Activate Region
  geoShield: "https://customer-assets.emergentagent.com/job_toon-threads-3d/artifacts/0zah2x2y_image.png",
  checkoutBlocked: "https://customer-assets.emergentagent.com/job_toon-threads-3d/artifacts/7zcfwua9_ChatGPT%20Image%20May%201%2C%202026%2C%2012_41_42%20AM.png",
  // Premiere Drop
  premiereLogo: "https://customer-assets.emergentagent.com/job_toon-threads-3d/artifacts/gs9xwyp4_Premimere%20Drop%20logo.png",
  premiereLeaderboard: "https://customer-assets.emergentagent.com/job_toon-threads-3d/artifacts/m7ixlnt4_image.png",
  // eGeez Adventures composition (3 phones + oh-geez stickers on orange + cloud horizon)
  adventuresComposition: "https://customer-assets.emergentagent.com/job_toon-threads-3d/artifacts/v6kc7945_image.png",
};

const fadeUp = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-60px" },
  transition: { duration: 0.6, ease: [0.16, 1, 0.3, 1] },
};

function Eyebrow({ children, color = "#0041E6" }) {
  return (
    <div className="inline-flex items-center gap-2 text-[11px] md:text-[12px] font-bold tracking-[0.28em] uppercase" style={{ color }}>
      <span className="inline-block w-6 h-px" style={{ background: color }} />
      {children}
    </div>
  );
}

// Pure-SVG/CSS event ticket — used in eGeez Adventures section
function Ticket({ title, subtitle, date, seat, color = "#0041E6", accent = "#FFD400" }) {
  return (
    <div className="relative w-full" style={{ filter: "drop-shadow(0 18px 30px rgba(0,0,0,0.25))" }}>
      <svg viewBox="0 0 320 140" className="w-full h-auto" aria-hidden>
        <defs>
          <linearGradient id={`tg-${color.replace("#", "")}`} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor={color} />
            <stop offset="100%" stopColor={color} stopOpacity="0.85" />
          </linearGradient>
        </defs>
        {/* Ticket body with notches on the sides */}
        <path
          d="M16 0 H214 V12 a10 10 0 0 1 0 20 V52 a10 10 0 0 1 0 20 V92 a10 10 0 0 1 0 20 V140 H16 V124 a10 10 0 0 0 0 -20 V84 a10 10 0 0 0 0 -20 V44 a10 10 0 0 0 0 -20 Z"
          fill={`url(#tg-${color.replace("#", "")})`}
        />
        {/* Right stub */}
        <path
          d="M222 0 H320 V140 H222 V124 a10 10 0 0 1 0 -20 V84 a10 10 0 0 1 0 -20 V44 a10 10 0 0 1 0 -20 Z"
          fill={color}
          opacity="0.85"
        />
        {/* Perforation dashed line */}
        <line x1="220" y1="6" x2="220" y2="134" stroke="#FFFFFF" strokeWidth="2" strokeDasharray="4 4" opacity="0.55" />
      </svg>
      {/* Overlay text — absolutely positioned over SVG */}
      <div className="absolute inset-0 flex">
        <div className="flex-1 px-5 py-4 flex flex-col justify-between text-white">
          <div>
            <div className="text-[8px] font-black tracking-[0.3em] uppercase" style={{ color: accent }}>
              ★ Admit One
            </div>
            <div className="font-display leading-[0.95] mt-1.5 text-[18px] md:text-[20px]">{title}</div>
            <div className="font-display italic text-[12px] md:text-[13px] leading-tight mt-0.5 text-white/90">{subtitle}</div>
          </div>
          <div className="flex items-end justify-between text-[9px] font-bold tracking-wider uppercase">
            <span className="text-white/80">{date}</span>
            <span className="bg-white/15 px-1.5 py-0.5 rounded-sm">{seat}</span>
          </div>
        </div>
        <div className="w-[28%] flex flex-col items-center justify-center text-white">
          <div className="text-[7px] font-black tracking-[0.25em] uppercase opacity-85">SEAT</div>
          <div className="font-display text-[22px] md:text-[26px] leading-none mt-0.5" style={{ color: accent }}>
            {seat.replace(/[A-Z\s]/g, "") || "07"}
          </div>
          <div className="text-[7px] font-black tracking-[0.25em] uppercase opacity-85 mt-1">eGEEZ</div>
        </div>
      </div>
    </div>
  );
}

// Animated phone preview — eGeez Voice tab demo video (starts at 0:16)
function RetailShelf() {
  const VIDEO_SRC =
    "https://customer-assets.emergentagent.com/job_toon-threads-3d/artifacts/91ze2e30_EgeezVoiceTab.mov";
  const START = 16;

  // Force playback to start at 0:16 on mount and on every loop
  const handleLoaded = (e) => {
    try {
      e.currentTarget.currentTime = START;
      e.currentTarget.play().catch(() => {});
    } catch {
      /* ignore */
    }
  };
  const handleTimeUpdate = (e) => {
    if (e.currentTarget.currentTime < START - 0.2) {
      e.currentTarget.currentTime = START;
    }
  };
  const handleEnded = (e) => {
    e.currentTarget.currentTime = START;
    e.currentTarget.play().catch(() => {});
  };

  return (
    <div
      className="relative w-full max-w-[300px] md:max-w-[340px] mx-auto"
      data-testid="promise-video-phone"
    >
      {/* Yellow glow halo */}
      <div className="absolute -inset-6 bg-[#FFD400]/20 blur-[60px] rounded-full pointer-events-none" aria-hidden />

      {/* Phone frame */}
      <div
        className="relative aspect-[9/19] rounded-[42px] p-[10px] shadow-[0_30px_80px_-20px_rgba(0,0,0,0.55)]"
        style={{
          background: "linear-gradient(160deg, #1a1a22 0%, #0b0b10 100%)",
        }}
      >
        {/* Notch */}
        <div className="absolute top-3 left-1/2 -translate-x-1/2 z-20 w-24 h-5 bg-black rounded-full" aria-hidden />

        <div className="relative w-full h-full rounded-[34px] overflow-hidden bg-black">
          <video
            className="w-full h-full object-cover"
            autoPlay
            muted
            playsInline
            loop
            preload="metadata"
            onLoadedMetadata={handleLoaded}
            onTimeUpdate={handleTimeUpdate}
            onEnded={handleEnded}
            poster=""
            data-testid="promise-video-el"
          >
            <source src={VIDEO_SRC} type="video/quicktime" />
            <source src={VIDEO_SRC} type="video/mp4" />
            Your browser does not support the video tag.
          </video>

          {/* subtle vignette */}
          <div
            className="absolute inset-0 pointer-events-none"
            style={{
              boxShadow: "inset 0 0 60px rgba(0,0,0,0.35)",
            }}
            aria-hidden
          />
        </div>
      </div>

      {/* Floating "Live demo" tag */}
      <motion.div
        animate={{ y: [0, -6, 0] }}
        transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
        className="absolute -top-3 -left-3 z-30 inline-flex items-center gap-1.5 bg-[#FFD400] text-black text-[10px] font-black tracking-[0.18em] uppercase px-3 py-1.5 rounded-full shadow-xl"
      >
        <Sparkles size={11} /> Live Demo
      </motion.div>

      {/* Floating "Verified Only" tag */}
      <motion.div
        animate={{ y: [0, -6, 0] }}
        transition={{ duration: 3, repeat: Infinity, ease: "easeInOut", delay: 0.4 }}
        className="absolute -bottom-3 -right-3 z-30 inline-flex items-center gap-1.5 bg-white text-[#0041E6] text-[10px] font-black tracking-[0.18em] uppercase px-3 py-1.5 rounded-full shadow-xl"
      >
        <Check size={11} strokeWidth={3} /> Verified Only
      </motion.div>
    </div>
  );
}

export default function Home() {
  return (
    <div data-testid="home-page" className="bg-[#FAFAFA]">

      {/* ============= 1. HERO — premium poster ============= */}
      <section
        className="relative pt-10 md:pt-16 pb-20 md:pb-28 overflow-hidden bg-white"
        data-testid="hero-section"
      >
        {/* BG1 brand background — full-bleed as user requested */}
        <img
          src={A.bgBlue}
          alt=""
          aria-hidden
          className="absolute inset-0 w-full h-full object-cover object-bottom pointer-events-none select-none"
          draggable={false}
        />
        <div className="absolute inset-0 bg-white/55 pointer-events-none" aria-hidden />
        {/* subtle radial accent */}
        <div className="absolute inset-0 -z-10 pointer-events-none">
          <div className="absolute -top-32 -right-40 w-[600px] h-[600px] rounded-full bg-[#0041E6]/8 blur-3xl" />
          <div className="absolute top-1/2 -left-40 w-[500px] h-[500px] rounded-full bg-[#FFD93D]/30 blur-3xl" />
        </div>

        <div className="mx-auto max-w-[1400px] px-5 md:px-12 relative z-10">
          <motion.div {...fadeUp} className="mb-10">
            <Eyebrow>The world's first · Licensed marketplace</Eyebrow>
          </motion.div>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">
            <div className="lg:col-span-7">
              <motion.h1
                {...fadeUp}
                className="font-display text-[#0041E6] leading-[0.88]"
                style={{ fontSize: "clamp(56px, 9.5vw, 168px)" }}
              >
                Every fandom.
                <br />
                <span className="text-black">One verified</span>
                <br />
                pocket.
              </motion.h1>
              <motion.p
                {...fadeUp}
                transition={{ duration: 0.55, delay: 0.08 }}
                className="mt-10 md:mt-12 text-[20px] md:text-[26px] font-semibold text-black italic leading-tight"
              >
                Everything licensed. Nothing fake. Ships to you.
              </motion.p>
              <motion.p
                {...fadeUp}
                transition={{ duration: 0.6, delay: 0.1 }}
                className="mt-8 text-[18px] md:text-[22px] text-black/70 leading-snug max-w-xl"
              >
                The world's first marketplace built only for officially licensed
                products — connecting fans directly to verified licensees. No middlemen.
                No counterfeits. Just the real thing.
              </motion.p>

              <motion.div
                {...fadeUp}
                transition={{ duration: 0.6, delay: 0.2 }}
                className="mt-10 flex flex-wrap items-center gap-4"
              >
                <a
                  href={T.joinWaitlist}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group bg-[#0041E6] hover:bg-[#0033B8] text-white font-medium text-[18px] rounded-full pl-7 pr-2 h-[56px] inline-flex items-center gap-3 transition shadow-[0_14px_30px_-12px_rgba(0,65,230,0.6)]"
                  data-testid="hero-join-waitlist-btn"
                >
                  Join the Waitlist
                  <span className="w-[40px] h-[40px] rounded-full bg-white text-[#0041E6] flex items-center justify-center transition-transform group-hover:rotate-45">
                    <ArrowUpRight size={18} />
                  </span>
                </a>
                <AppStoreBadges size="sm" />
              </motion.div>

              <motion.div
                {...fadeUp}
                transition={{ duration: 0.6, delay: 0.3 }}
                className="mt-12 grid grid-cols-3 gap-6 max-w-md border-t border-black/10 pt-6"
              >
                {[
                  ["100%", "Verified"],
                  ["0", "Counterfeits"],
                  ["1", "Pocket"],
                ].map(([k, v]) => (
                  <div key={v}>
                    <div className="font-display text-[#0041E6] text-[40px] md:text-[44px] leading-none">{k}</div>
                    <div className="text-[12px] uppercase tracking-widest text-black/60 mt-1">{v}</div>
                  </div>
                ))}
              </motion.div>
            </div>

            {/* Phone visual */}
            <motion.div
              initial={{ opacity: 0, scale: 0.92 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
              className="lg:col-span-5 relative flex justify-center"
            >
              <div className="relative flex flex-col items-center lg:block">
                {/* Subtitle pill above phone — inline on mobile/tablet, absolute on desktop */}
                <motion.div
                  initial={{ opacity: 0, y: -10 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: 0.2 }}
                  className="relative mb-6 lg:mb-0 lg:absolute lg:-top-24 lg:left-0 z-30 inline-flex items-center gap-2.5 bg-black text-white text-[11px] sm:text-[12px] md:text-[15px] font-black tracking-[0.18em] md:tracking-[0.2em] uppercase px-4 sm:px-5 py-2 md:py-2.5 rounded-full shadow-xl whitespace-nowrap max-w-[92vw]"
                >
                  <span className="w-2 h-2 rounded-full bg-[#FFD400] animate-pulse flex-shrink-0" />
                  <span className="truncate">Scroll Fandoms Near You · Verified Only</span>
                </motion.div>
                {/* Oh, Geez! blue logo sticker — sits alongside the phone (mid) on mobile to avoid the pill */}
                <motion.img
                  src={A.ohGeezLogo}
                  alt="Oh, Geez!"
                  className="absolute top-[38%] -right-2 sm:-right-4 lg:top-auto lg:-top-4 lg:-right-4 z-20 w-20 sm:w-24 md:w-32 lg:w-36 h-auto rotate-[-8deg] drop-shadow-[0_12px_24px_rgba(0,65,230,0.35)] pointer-events-none"
                  initial={{ opacity: 0, scale: 0.6, rotate: -20 }}
                  whileInView={{ opacity: 1, scale: 1, rotate: -8 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
                />
                <div className="relative">
                  {/* Soft yellow glow halo behind phone */}
                  <div className="absolute -inset-6 bg-[#FFD400]/15 blur-[80px] rounded-[60%] pointer-events-none" aria-hidden />
                  {/* Transparent phone PNG — float naturally, no CSS frame */}
                  <motion.img
                    src={A.heroPhone}
                    alt="eGeez app"
                    className="relative mx-auto w-[260px] sm:w-[300px] md:w-[360px] lg:w-[440px] h-auto drop-shadow-[0_30px_60px_rgba(0,0,0,0.35)] animate-floatY"
                    draggable={false}
                    data-testid="hero-phone-img"
                  />
                </div>
                {/* tag */}
                <div className="absolute bottom-6 -left-4 z-20 bg-white border border-black/10 rounded-2xl px-4 py-3 shadow-lg rotate-[-4deg] hidden md:block">
                  <div className="text-[10px] uppercase tracking-widest font-bold text-black/50">Fans Following</div>
                  <div className="font-display text-[#0041E6] text-[22px] leading-none mt-1">200,000+</div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* ============= 2. MARQUEE ============= */}
      <div className="border-y border-black/10 bg-[#0041E6] py-6 overflow-hidden" data-testid="marquee-strip">
        <div className="flex animate-scrollX whitespace-nowrap will-change-transform" style={{ width: "200%" }}>
          {[...Array(2)].map((_, i) => (
            <div key={i} className="flex items-center gap-12 px-6">
              {["Region-Unlocked", "0% Counterfeits", "Unlocked fandom", "Unlimited Shelves", "Premiere Drops", "Below Retail", "IP Discovery"].map((t, j) => (
                <span key={j} className="flex items-center gap-12 font-display text-white text-[40px] md:text-[56px] leading-none">
                  {t}
                  <span className="inline-block w-3 h-3 rounded-full bg-[#FFD93D]" />
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>

      {/* ============= 3. THE BLUE PROMISE — Comic-Con shelf experience ============= */}
      <section
        className="relative py-24 md:py-36 overflow-hidden"
        style={{
          background:
            "radial-gradient(120% 80% at 50% 0%, #0033B8 0%, #001F6E 60%, #000B33 100%)",
        }}
        data-testid="promise-section"
      >
        {/* Sparkle / confetti particles */}
        <div className="absolute inset-0 pointer-events-none overflow-hidden" aria-hidden>
          {Array.from({ length: 28 }).map((_, i) => {
            const colors = ["#FFD400", "#FF6B6B", "#22D3EE", "#A78BFA", "#FFFFFF"];
            const c = colors[i % colors.length];
            const left = (i * 37) % 100;
            const top = (i * 53) % 100;
            const dur = 5 + (i % 5);
            const delay = (i % 7) * 0.4;
            return (
              <motion.span
                key={i}
                className="absolute rounded-full"
                style={{
                  left: `${left}%`,
                  top: `${top}%`,
                  width: i % 3 === 0 ? 6 : 4,
                  height: i % 3 === 0 ? 6 : 4,
                  background: c,
                  boxShadow: `0 0 12px ${c}`,
                }}
                animate={{
                  y: ["0%", "-30%", "0%"],
                  opacity: [0.2, 1, 0.2],
                  scale: [0.7, 1.2, 0.7],
                }}
                transition={{
                  duration: dur,
                  delay,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
              />
            );
          })}
        </div>

        {/* Soft yellow halo behind text */}
        <div
          className="absolute -top-32 left-1/2 -translate-x-1/2 w-[80%] h-[400px] opacity-40 pointer-events-none"
          style={{
            background:
              "radial-gradient(ellipse at center, rgba(255, 212, 0, 0.35) 0%, transparent 65%)",
          }}
          aria-hidden
        />

        <div className="mx-auto max-w-[1400px] px-5 md:px-12 relative">
          {/* Eyebrow */}
          <motion.div
            {...fadeUp}
            className="flex items-center gap-3 text-[10px] md:text-[11px] tracking-[0.4em] uppercase text-[#FFD400] mb-6"
          >
            <span className="w-10 h-px bg-[#FFD400]/60" />
            The Blue Promise
            <Sparkles size={14} className="text-[#FFD400]" />
          </motion.div>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            <motion.div {...fadeUp} className="lg:col-span-7">
              <h2
                className="font-display text-white leading-[0.92] drop-shadow-[0_4px_28px_rgba(0,0,0,0.45)]"
                style={{ fontSize: "clamp(40px, 7vw, 96px)" }}
              >
                Fans &amp; licensees,<br />
                <span className="text-[#FFD400]">finally on the same shelf.</span>
              </h2>
              <p className="mt-6 font-display italic text-white/90 leading-snug" style={{ fontSize: "clamp(18px, 2vw, 24px)" }}>
                Like Comic Con just opened its doors — and everything inside is verified and waiting for you. 🎉
              </p>
            </motion.div>

            {/* Animated retail shelf */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
              className="lg:col-span-5"
              data-testid="retail-shelf-visual"
            >
              <RetailShelf />
            </motion.div>
          </div>

          {/* Description */}
          <motion.p
            {...fadeUp}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="mt-12 max-w-3xl text-[16px] md:text-[18px] text-white/75 leading-relaxed"
          >
            eGeez is a unique, industry-first platform — a dedicated marketplace exclusively for licensed products that connects fans directly to licensees.
            All official, all in one place. No counterfeits, no inflated middleman pricing, no guesswork.
          </motion.p>

          {/* Rally cry */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95, y: 20 }}
            whileInView={{ opacity: 1, scale: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
            className="mt-12 md:mt-16 relative"
          >
            <div
              className="font-display italic text-white leading-[1.05] drop-shadow-[0_4px_24px_rgba(0,0,0,0.55)]"
              style={{ fontSize: "clamp(28px, 4.4vw, 56px)" }}
            >
              Retail got <span className="text-[#FF6B6B]">greedy.</span><br />
              Loyal fans got <span className="text-[#FF6B6B]">overcharged.</span><br />
              It <span className="text-[#FFD400]">stops now!</span>
            </div>
          </motion.div>

          {/* 3 glowing colored cards */}
          <motion.div
            {...fadeUp}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-5"
          >
            {[
              {
                t: "Direct-to-fan",
                b: "Skip resellers. Buy from verified licensees, the source.",
                color: "#FFD400",
                icon: Heart,
                bg: "linear-gradient(135deg, rgba(255,212,0,0.18) 0%, rgba(255,212,0,0.04) 100%)",
                border: "rgba(255,212,0,0.4)",
              },
              {
                t: "Lower prices",
                b: "Removing the middleman keeps more value with fans.",
                color: "#22D3EE",
                icon: Tag,
                bg: "linear-gradient(135deg, rgba(34,211,238,0.18) 0%, rgba(34,211,238,0.04) 100%)",
                border: "rgba(34,211,238,0.4)",
              },
              {
                t: "Authentic only",
                b: "Every licensee verified. Every product trademarked.",
                color: "#A78BFA",
                icon: ShieldCheck,
                bg: "linear-gradient(135deg, rgba(167,139,250,0.18) 0%, rgba(167,139,250,0.04) 100%)",
                border: "rgba(167,139,250,0.4)",
              },
            ].map((p, i) => {
              const Icon = p.icon;
              return (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 24 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-40px" }}
                  transition={{ duration: 0.6, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
                  whileHover={{ y: -6 }}
                  className="relative rounded-[24px] p-7 backdrop-blur-md border overflow-hidden group"
                  style={{
                    background: p.bg,
                    borderColor: p.border,
                    boxShadow: `inset 0 1px 0 rgba(255,255,255,0.08)`,
                  }}
                >
                  {/* glow on hover */}
                  <div
                    className="absolute -inset-10 opacity-30 group-hover:opacity-70 transition-opacity duration-500 pointer-events-none"
                    style={{
                      background: `radial-gradient(circle at 50% 0%, ${p.color}55 0%, transparent 60%)`,
                    }}
                    aria-hidden
                  />
                  <div className="relative">
                    <div
                      className="inline-flex items-center justify-center w-11 h-11 rounded-2xl mb-5"
                      style={{
                        background: `${p.color}22`,
                        boxShadow: `0 0 24px ${p.color}33`,
                      }}
                    >
                      <Icon size={22} color={p.color} strokeWidth={2.2} />
                    </div>
                    <div
                      className="font-display text-[26px] md:text-[30px] leading-tight"
                      style={{ color: p.color }}
                    >
                      {p.t}
                    </div>
                    <p className="mt-3 text-[15px] text-white/75 leading-snug">{p.b}</p>
                  </div>
                </motion.div>
              );
            })}
          </motion.div>
        </div>
      </section>

      {/* ============= 4. FEATURES BENTO ============= */}
      <section id="features" className="relative py-24 md:py-32 bg-white border-y border-black/5" data-testid="features-section">
        <div className="mx-auto max-w-[1400px] px-5 md:px-12">
          <motion.div {...fadeUp} className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
            <div>
              <Eyebrow>Inside the app</Eyebrow>
              <h2 className="mt-5 font-display text-black text-[48px] md:text-[80px] leading-[0.92]">
                Built for the<br />
                <span className="text-[#0041E6]">true fan.</span>
              </h2>
            </div>
            <p className="md:max-w-md text-[16px] md:text-[18px] text-black/60 leading-snug">
              Every feature designed with one mission — make finding, gifting and collecting officially licensed products effortless.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-12 gap-5">
            {/* eGifts — purple, tall */}
            <motion.div
              {...fadeUp}
              className="md:col-span-5 md:row-span-2 relative rounded-[32px] overflow-hidden p-8 pb-10 text-white min-h-[680px] flex flex-col"
              style={{ background: "linear-gradient(180deg, #B07BFF 0%, #9747FF 100%)" }}
              data-testid="feature-gifts"
            >
              {/* Animated decorative gift elements scattered in background */}
              {[
                { Icon: Gift, l: "78%", t: "8%", size: 28, c: "#FFD400", d: 0, r: 12 },
                { Icon: Sparkles, l: "8%", t: "32%", size: 22, c: "#FFD400", d: 0.6, r: 0 },
                { Icon: Gift, l: "72%", t: "44%", size: 24, c: "#FF4DA6", d: 1.2, r: -18 },
                { Icon: Sparkles, l: "82%", t: "62%", size: 18, c: "#FFFFFF", d: 0.3, r: 0 },
                { Icon: Heart, l: "6%", t: "62%", size: 20, c: "#FF4DA6", d: 0.9, r: 8 },
                { Icon: Sparkles, l: "20%", t: "8%", size: 16, c: "#FFFFFF", d: 1.5, r: 0 },
              ].map((el, i) => {
                const Ico = el.Icon;
                return (
                  <motion.span
                    key={i}
                    aria-hidden
                    className="absolute pointer-events-none"
                    style={{ left: el.l, top: el.t, color: el.c }}
                    animate={{
                      y: [0, -10, 0, -4, 0],
                      rotate: [el.r, el.r + 12, el.r - 8, el.r + 6, el.r],
                      scale: [0.9, 1.1, 0.95, 1.05, 0.9],
                      opacity: [0.6, 1, 0.7, 0.95, 0.6],
                    }}
                    transition={{
                      duration: 4 + (i % 3),
                      delay: el.d,
                      repeat: Infinity,
                      ease: "easeInOut",
                    }}
                  >
                    <Ico size={el.size} fill={el.Icon === Heart ? el.c : "transparent"} strokeWidth={2} />
                  </motion.span>
                );
              })}

              {/* Floating gift emojis (rendered via SVG box ribbons) */}
              {[
                { l: "62%", t: "16%", s: 18, c: "#FFD400", d: 0.4 },
                { l: "12%", t: "44%", s: 14, c: "#22D3EE", d: 1.1 },
                { l: "85%", t: "30%", s: 12, c: "#FFFFFF", d: 0.8 },
              ].map((b, i) => (
                <motion.svg
                  key={`box-${i}`}
                  aria-hidden
                  viewBox="0 0 24 24"
                  className="absolute pointer-events-none"
                  style={{ left: b.l, top: b.t, width: b.s, height: b.s, color: b.c }}
                  animate={{
                    y: [0, -8, 0, -3, 0],
                    rotate: [-8, 8, -4, 6, -8],
                    opacity: [0.5, 1, 0.7, 1, 0.5],
                  }}
                  transition={{ duration: 5 + i, delay: b.d, repeat: Infinity, ease: "easeInOut" }}
                >
                  <rect x="3" y="9" width="18" height="11" rx="1.5" fill={b.c} opacity="0.85" />
                  <rect x="2" y="6" width="20" height="4" rx="1" fill={b.c} />
                  <rect x="11" y="6" width="2" height="14" fill="#9747FF" />
                  <path d="M12 6 C 8 2, 6 5, 12 6 C 18 5, 16 2, 12 6 Z" fill={b.c} />
                </motion.svg>
              ))}

              {/* Pure CSS eGifts wordmark — deploy-safe */}
              <div className="relative z-10 flex items-baseline gap-1 select-none" data-testid="egifts-logo">
                <span
                  className="font-display text-white leading-none"
                  style={{ fontSize: "clamp(46px, 5.5vw, 64px)" }}
                >
                  e
                </span>
                <span
                  className="font-display text-white leading-none"
                  style={{ fontSize: "clamp(38px, 4.5vw, 54px)" }}
                >
                  Gifts
                </span>
              </div>

              <p className="relative z-10 mt-5 text-[18px] leading-[1.2] max-w-[340px]">
                Send digital gift cards to your loved ones, redeemable for their favorite licensed products. The perfect way to gift something unique and officially licensed.
              </p>

              {/* COMING SOON — typography centered, beneath body, above cards */}
              <motion.div
                initial={{ opacity: 0, y: 14, rotate: -3 }}
                whileInView={{ opacity: 1, y: 0, rotate: -2 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7, delay: 0.25, ease: [0.16, 1, 0.3, 1] }}
                animate={{ rotate: [-2, 0, -4, -2], y: [0, -3, 0] }}
                style={{ transition: "none" }}
                className="relative z-10 mt-8 mb-6 text-center"
                data-testid="egifts-coming-soon"
              >
                <div className="inline-flex items-center justify-center gap-2 text-[10px] font-black tracking-[0.4em] uppercase text-[#FFD400] mb-2">
                  <span className="text-[12px]">★</span>
                  Stay Browsed
                  <span className="text-[12px]">★</span>
                </div>
                <div
                  className="font-display italic text-white leading-[0.9] drop-shadow-[0_8px_24px_rgba(0,0,0,0.35)]"
                  style={{ fontSize: "clamp(36px, 4.5vw, 56px)" }}
                >
                  Coming{" "}
                  <span className="text-[#FFD400]">Soon</span>
                </div>
              </motion.div>

              {/* Two cards — fanned out, fully visible, no clipping */}
              <div className="relative z-10 mt-auto h-[220px] md:h-[240px] mx-auto w-full max-w-[440px]">
                {/* Garfield card */}
                <motion.img
                  src={A.giftCardGarfield}
                  alt=""
                  initial={{ opacity: 0, x: -20, rotate: -16 }}
                  whileInView={{ opacity: 1, x: 0, rotate: -10 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.7, delay: 0.4, ease: [0.16, 1, 0.3, 1] }}
                  animate={{
                    y: [0, -8, 0, -3, 0],
                    rotate: [-10, -7, -13, -9, -10],
                  }}
                  style={{ transition: "none" }}
                  className="absolute left-0 bottom-0 w-[52%] rounded-2xl shadow-2xl ring-1 ring-black/10 z-[1]"
                  draggable={false}
                  data-testid="giftcard-garfield"
                />

                {/* Angel card */}
                <motion.img
                  src={A.giftCardAngel}
                  alt=""
                  initial={{ opacity: 0, x: 20, rotate: 18 }}
                  whileInView={{ opacity: 1, x: 0, rotate: 12 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.7, delay: 0.55, ease: [0.16, 1, 0.3, 1] }}
                  animate={{
                    y: [0, -6, 0, -10, 0],
                    rotate: [12, 9, 15, 11, 12],
                  }}
                  style={{ transition: "none" }}
                  className="absolute right-0 bottom-0 w-[52%] rounded-2xl shadow-2xl ring-1 ring-black/10 z-[2]"
                  draggable={false}
                  data-testid="giftcard-angel"
                />
              </div>
            </motion.div>

            {/* Sorting Hat — light blue, wide. Animated phone mock with categories + characters (pure CSS, deploy-safe) */}
            <motion.div
              {...fadeUp}
              transition={{ duration: 0.6, delay: 0.05 }}
              className="md:col-span-7 relative rounded-[32px] overflow-hidden p-7 sm:p-8 min-h-[330px] sm:min-h-[360px] md:min-h-[380px]"
              style={{ background: "#D4F8FF" }}
              data-testid="feature-sorting-hat"
            >
              <h3 className="font-display text-[28px] sm:text-[32px] md:text-[40px] text-black leading-[0.95] max-w-[58%] sm:max-w-[60%] break-words">
                Your fandoms.<br />Your shelf.<br /><span className="text-[#0041E6]">Always updated.</span>
              </h3>
              <p className="mt-3 sm:mt-4 text-[12px] sm:text-[14px] leading-snug max-w-[58%] sm:max-w-[55%] text-black/80">
                Pick your favorites once — Garfield, Batman, Stranger Things, whatever moves you. eGeez tracks every licensed drop, toy, and release in your territory automatically.
              </p>
              <p className="mt-2 text-[13px] sm:text-[15px] font-bold italic text-[#0041E6] max-w-[58%] sm:max-w-[55%]">
                Never miss a drop again.
              </p>

              {/* Animated preference chips floating beneath the copy (left half) */}
              <div className="relative mt-4 hidden sm:flex flex-wrap gap-2 max-w-[60%]">
                {[
                  { t: "Toys & Games", c: "#0041E6" },
                  { t: "Fashion", c: "#FF4DA6" },
                  { t: "Celebrities", c: "#9747FF" },
                ].map((chip, i) => (
                  <motion.span
                    key={chip.t}
                    initial={{ opacity: 0, y: 6 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.2 + i * 0.1, duration: 0.5 }}
                    className="inline-flex items-center gap-1.5 bg-white text-[11px] font-bold px-3 py-1.5 rounded-full shadow-sm ring-1 ring-black/5"
                    style={{ color: chip.c }}
                  >
                    <span className="w-1.5 h-1.5 rounded-full" style={{ background: chip.c }} />
                    {chip.t}
                  </motion.span>
                ))}
              </div>

              {/* Phone mock — right side, animated. Use fixed height to guarantee fit inside the card. */}
              <div className="absolute right-4 sm:right-6 md:right-8 top-1/2 -translate-y-1/2 pointer-events-none">
                <motion.div
                  initial={{ y: 20, opacity: 0 }}
                  whileInView={{ y: 0, opacity: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
                  className="relative h-[260px] sm:h-[300px] md:h-[330px] aspect-[9/19] rounded-[26px] p-[4px] shadow-[0_18px_40px_-12px_rgba(0,0,0,0.35)]"
                  style={{ background: "linear-gradient(160deg, #1a1a22 0%, #0b0b10 100%)" }}
                >
                  {/* Notch */}
                  <div className="absolute top-1.5 left-1/2 -translate-x-1/2 z-20 w-12 h-2.5 bg-black rounded-full" aria-hidden />
                  {/* Screen */}
                  <div
                    className="relative w-full h-full rounded-[22px] overflow-hidden"
                    style={{ background: "linear-gradient(180deg, #DDF4FF 0%, #B6E4FF 100%)" }}
                  >
                    {/* Status bar */}
                    <div className="flex justify-between items-center px-3 pt-3 text-[7px] font-bold text-black/70">
                      <span>9:41</span>
                      <span>•••</span>
                    </div>

                    {/* Title */}
                    <div className="px-3 mt-1">
                      <div className="font-display text-black text-[13px] leading-tight">Sorting Hat</div>
                      <div className="text-[7px] text-black/55 mt-0.5">Pick your favourites</div>
                    </div>

                    {/* Animated category list */}
                    <div className="px-2.5 mt-2 space-y-1.5">
                      {[
                        { l: "Toys & Games", c: "#0041E6", delay: 0 },
                        { l: "Fashion", c: "#FF4DA6", delay: 0.6 },
                        { l: "Celebrities", c: "#9747FF", delay: 1.2 },
                      ].map((row, i) => (
                        <motion.div
                          key={i}
                          className="bg-white rounded-md px-2 py-1.5 flex items-center justify-between shadow-sm"
                        >
                          <div className="flex items-center gap-1.5">
                            <span
                              className="w-3 h-3 rounded-sm flex items-center justify-center"
                              style={{ background: row.c }}
                            >
                              <span className="text-white text-[6px] font-black">e</span>
                            </span>
                            <span className="text-[8px] font-bold text-black">{row.l}</span>
                          </div>
                          <motion.span
                            className="w-2.5 h-2.5 rounded-full border"
                            style={{ borderColor: row.c }}
                            animate={{
                              backgroundColor: ["#FFFFFF", row.c, row.c, "#FFFFFF"],
                            }}
                            transition={{
                              duration: 4,
                              delay: row.delay,
                              repeat: Infinity,
                              ease: "easeInOut",
                              times: [0, 0.25, 0.85, 1],
                            }}
                          />
                        </motion.div>
                      ))}
                    </div>

                    {/* Character bubbles row */}
                    <div className="px-2.5 mt-2">
                      <div className="text-[7px] font-bold text-black/60 mb-1">Characters</div>
                      <div className="flex gap-1 flex-wrap">
                        {[
                          { n: "Garfield", c: "#FF8C42" },
                          { n: "Batman", c: "#1A1A1A" },
                          { n: "Scooby", c: "#7CB342" },
                          { n: "Hulk", c: "#E63946" },
                        ].map((ch, i) => (
                          <motion.span
                            key={ch.n}
                            initial={{ scale: 0.6, opacity: 0 }}
                            animate={{
                              scale: [0.6, 1, 1, 0.95, 1],
                              opacity: [0, 1, 1, 1, 1],
                            }}
                            transition={{
                              duration: 3,
                              delay: 0.3 + i * 0.25,
                              repeat: Infinity,
                              repeatDelay: 2,
                            }}
                            className="text-[6.5px] font-bold text-white px-1.5 py-0.5 rounded-full"
                            style={{ background: ch.c }}
                          >
                            {ch.n}
                          </motion.span>
                        ))}
                      </div>
                    </div>

                    {/* "Done" pulsing CTA */}
                    <motion.div
                      animate={{ scale: [1, 1.04, 1] }}
                      transition={{ duration: 1.6, repeat: Infinity, ease: "easeInOut" }}
                      className="absolute left-2.5 right-2.5 bottom-2.5 bg-[#0041E6] text-white text-[8px] font-black tracking-wider uppercase py-1.5 rounded-md text-center shadow-md"
                    >
                      Sort My Shelf
                    </motion.div>
                  </div>
                </motion.div>

                {/* Floating sparkles around the phone */}
                {[
                  { l: "-12%", t: "10%", d: 0 },
                  { l: "-8%", t: "60%", d: 1.2 },
                  { l: "100%", t: "30%", d: 0.6 },
                ].map((s, i) => (
                  <motion.span
                    key={i}
                    aria-hidden
                    className="absolute text-[#0041E6]"
                    style={{ left: s.l, top: s.t }}
                    animate={{
                      scale: [0.5, 1.1, 0.5],
                      opacity: [0.3, 1, 0.3],
                      rotate: [0, 180, 360],
                    }}
                    transition={{
                      duration: 3.5,
                      delay: s.d,
                      repeat: Infinity,
                      ease: "easeInOut",
                    }}
                  >
                    <Sparkles size={12} />
                  </motion.span>
                ))}
              </div>
            </motion.div>

            {/* Voice — yellow */}
            <motion.div
              {...fadeUp}
              transition={{ duration: 0.6, delay: 0.1 }}
              className="md:col-span-3 relative rounded-[32px] overflow-hidden p-6 sm:p-7 min-h-[300px] sm:min-h-[270px]"
              style={{ background: "#FCFF6F" }}
              data-testid="feature-voice"
            >
              <h3 className="font-display text-[34px] sm:text-[36px] text-black leading-none">Voice</h3>
              <p className="mt-3 text-[13px] sm:text-[14px] leading-snug max-w-[58%] sm:max-w-[180px] text-black/85">
                Find what you want faster — just speak.
              </p>
              <p className="mt-3 text-[12px] sm:text-[13px] leading-snug max-w-[58%] sm:max-w-[180px] text-black font-semibold italic">
                Say &ldquo;Garfield&rdquo;… <br />And it&rsquo;s delivered!<br />
                <span className="text-[#0041E6]">eGeez is eazy!</span>
              </p>

              {/* Animated ripple — right side, away from text */}
              <div className="absolute -right-6 sm:-right-4 -bottom-6 sm:-bottom-4 w-[55%] sm:w-[60%] aspect-square pointer-events-none">
                {/* Expanding ripple rings */}
                {[0, 1, 2].map((i) => (
                  <motion.span
                    key={i}
                    className="absolute inset-0 rounded-full border-2 border-[#0041E6]"
                    initial={{ scale: 0.5, opacity: 0.7 }}
                    animate={{ scale: 1.15, opacity: 0 }}
                    transition={{
                      duration: 2.4,
                      delay: i * 0.8,
                      repeat: Infinity,
                      ease: "easeOut",
                    }}
                  />
                ))}
                {/* Centered ripple PNG */}
                <motion.img
                  src={A.voiceRipple}
                  alt=""
                  className="relative w-full h-full object-contain"
                  animate={{ scale: [1, 1.04, 1] }}
                  transition={{ duration: 2.2, repeat: Infinity, ease: "easeInOut" }}
                  draggable={false}
                />
              </div>
            </motion.div>

            {/* Gems — dark teal */}
            <motion.div
              {...fadeUp}
              transition={{ duration: 0.6, delay: 0.15 }}
              className="md:col-span-4 relative rounded-[32px] overflow-hidden p-6 sm:p-7 text-white min-h-[300px] sm:min-h-[270px]"
              style={{ background: "linear-gradient(135deg, #5A8E84 0%, #2E4A45 100%)" }}
              data-testid="feature-gems"
            >
              <h3 className="font-display text-[36px] sm:text-[40px] text-white leading-none">Gems</h3>
              <p className="mt-3 text-[14px] sm:text-[15px] leading-tight max-w-[55%] sm:max-w-[200px]">
                Earn Gems with every purchase. Collect them. Pay with them.
              </p>

              {/* Animated floating gems cluster — right side, away from text */}
              <div className="absolute -right-2 -top-2 w-[44%] sm:w-[55%] h-full pointer-events-none">
                {/* Glow halo behind gems */}
                <div className="absolute right-6 top-1/2 -translate-y-1/2 w-32 h-32 bg-cyan-400/25 blur-3xl rounded-full" aria-hidden />

                {[
                  { size: "w-20 sm:w-32", pos: "right-3 top-2", dur: 3.4, delay: 0, rot: -6 },
                  { size: "w-14 sm:w-20", pos: "right-1 top-20 sm:top-28", dur: 4.0, delay: 0.6, rot: 8 },
                  { size: "w-10 sm:w-14", pos: "right-12 sm:right-20 bottom-6", dur: 3.2, delay: 0.3, rot: -10 },
                  { size: "w-8 sm:w-10", pos: "right-3 bottom-1", dur: 3.8, delay: 0.9, rot: 14 },
                ].map((g, i) => (
                  <motion.img
                    key={i}
                    src={A.gemDiamond}
                    alt=""
                    className={`absolute ${g.pos} ${g.size} drop-shadow-[0_8px_20px_rgba(34,211,238,0.55)]`}
                    initial={{ rotate: g.rot }}
                    animate={{
                      y: [0, -8, 0],
                      rotate: [g.rot - 4, g.rot + 4, g.rot - 4],
                    }}
                    transition={{
                      duration: g.dur,
                      delay: g.delay,
                      repeat: Infinity,
                      ease: "easeInOut",
                    }}
                    draggable={false}
                  />
                ))}
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* ============= 5. ADVENTURES — moved further down (replaces old Premiere Drop) ============= */}

      {/* ============= 6. GEOFENCING — same design as For Licensees (Sign-Up removed) ============= */}
      <section className="relative pb-24 pt-24 md:pt-32 bg-white" data-testid="geofencing-section">
        <div className="mx-auto max-w-[1400px] px-5 md:px-12">
          <motion.div {...fadeUp} className="rounded-[40px] overflow-hidden grid grid-cols-1 md:grid-cols-5 min-h-[520px]" style={{ background: "#1F3933" }}>
            {/* LEFT — BIG "We can't ship" checkout image + flying evil emojis + alerts */}
            <div className="relative md:col-span-3 bg-gradient-to-br from-[#FFB347] to-[#FF6B6B] flex items-center justify-center p-6 md:p-10 overflow-hidden min-h-[420px]">
              {/* Flying evil emojis */}
              <motion.span
                aria-hidden
                animate={{ x: [-20, 20, -20], y: [0, -8, 0], rotate: [-10, 10, -10] }}
                transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
                className="absolute top-6 left-6 text-4xl md:text-5xl select-none pointer-events-none z-20"
              >
                👿
              </motion.span>
              <motion.span
                aria-hidden
                animate={{ x: [10, -15, 10], y: [-6, 8, -6], rotate: [8, -8, 8] }}
                transition={{ duration: 5, repeat: Infinity, ease: "easeInOut", delay: 0.6 }}
                className="absolute top-14 right-10 text-3xl md:text-4xl select-none pointer-events-none z-20"
              >
                😈
              </motion.span>
              <motion.span
                aria-hidden
                animate={{ y: [0, -14, 0], rotate: [-6, 6, -6] }}
                transition={{ duration: 3.2, repeat: Infinity, ease: "easeInOut", delay: 1.2 }}
                className="absolute bottom-8 left-12 text-3xl select-none pointer-events-none z-20"
              >
                🚫
              </motion.span>

              {/* Red alert pulsing stripe */}
              <motion.div
                animate={{ opacity: [0.6, 1, 0.6] }}
                transition={{ duration: 1.8, repeat: Infinity, ease: "easeInOut" }}
                className="absolute top-4 left-1/2 -translate-x-1/2 z-20 bg-[#E63946] text-white text-[10px] font-black tracking-[0.24em] uppercase px-3 py-1.5 rounded-full shadow-lg flex items-center gap-2"
              >
                <AlertTriangle size={12} strokeWidth={3} />
                Territorial Breach Blocked
              </motion.div>

              {/* Yellow warning */}
              <motion.div
                animate={{ y: [0, -4, 0] }}
                transition={{ duration: 2.4, repeat: Infinity, ease: "easeInOut" }}
                className="absolute bottom-5 right-5 z-20 bg-[#FFD400] text-black text-[10px] font-black tracking-[0.18em] uppercase px-3 py-1.5 rounded-full shadow-md flex items-center gap-1.5"
              >
                ⚠️ Region-locked
              </motion.div>

              {/* BIG Checkout screenshot — centered, floating */}
              <motion.div
                animate={{ y: [0, -10, 0] }}
                transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
                className="relative z-[5] w-full max-w-[560px]"
              >
                <div className="absolute -inset-6 bg-white/30 blur-3xl rounded-3xl" aria-hidden />
                <img
                  src={A.cannotShip}
                  alt="We can't ship this item to your region — geofenced checkout"
                  className="relative w-full h-auto rounded-2xl shadow-[0_40px_80px_-20px_rgba(0,0,0,0.55)] ring-1 ring-black/10"
                  draggable={false}
                />
              </motion.div>
            </div>

            {/* RIGHT — copy + smaller GeoShield (no Sign-Up button on /for-fans) */}
            <div className="relative md:col-span-2 p-10 md:p-12 text-white flex flex-col justify-center overflow-hidden">
              <div className="inline-flex items-center gap-2 text-[10px] md:text-[11px] font-black tracking-[0.28em] uppercase text-[#FFD400] mb-4">
                <span className="inline-block w-6 h-px bg-[#FFD400]" />
                GeoShield · Region Aware
              </div>

              <h3 className="font-display italic text-[32px] md:text-[44px] leading-[0.95]">Geofencing Licensed Products</h3>

              {/* Discoverability Unlocked — headline accent */}
              <motion.div
                initial={{ opacity: 0, x: -10 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.2 }}
                className="mt-3 font-display italic text-[24px] md:text-[32px] leading-[1] text-[#FFD400]"
              >
                Discoverability Unlocked.
              </motion.div>

              {/* Smaller GeoShield — sits inline */}
              <motion.div
                initial={{ opacity: 0, scale: 0.85, rotate: -10 }}
                whileInView={{ opacity: 1, scale: 1, rotate: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: 0.3, ease: [0.16, 1, 0.3, 1] }}
                className="mt-6 relative w-[90px] md:w-[110px] pointer-events-none select-none"
              >
                <div className="absolute -inset-3 bg-[#FFD400]/30 blur-2xl rounded-full" aria-hidden />
                <motion.img
                  src={A.geoShield}
                  alt="eGeez GeoShield"
                  animate={{ y: [0, -5, 0], rotate: [-3, 3, -3] }}
                  transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
                  className="relative w-full h-auto drop-shadow-[0_20px_40px_rgba(255,212,0,0.45)]"
                  draggable={false}
                />
              </motion.div>

              <p className="mt-6 text-[14px] md:text-[15px] leading-relaxed text-white/90">
                By capturing exact licensed territories from your agreements, eGeez geolocates official licensed products so they only appear to fans in approved regions. Licensors safeguarded. Fans served localized, seamless shopping.
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* ============= 6.5 ACTIVATE YOUR REGION — classified / military ============= */}
      <section
        className="relative py-24 md:py-32 overflow-hidden"
        style={{ background: "#0A1629" }}
        data-testid="activate-region-section"
      >
        {/* Subtle HUD grid */}
        <div
          className="absolute inset-0 pointer-events-none opacity-[0.08]"
          style={{
            backgroundImage:
              "linear-gradient(to right, #FFFFFF 1px, transparent 1px), linear-gradient(to bottom, #FFFFFF 1px, transparent 1px)",
            backgroundSize: "100px 100px",
          }}
          aria-hidden
        />
        {/* HUD coordinates strips */}
        <div className="absolute top-6 left-6 right-6 flex justify-between text-[10px] tracking-[0.3em] uppercase text-white/35 font-mono pointer-events-none">
          <span>LAT 43.6532° N</span>
          <span>SYS · GEO-SHIELD</span>
          <span>LON 79.3832° W</span>
        </div>
        <div className="absolute bottom-6 left-6 right-6 flex justify-between text-[10px] tracking-[0.3em] uppercase text-white/35 font-mono pointer-events-none">
          <span>CLASSIFIED · TIER 01</span>
          <span>eGeez / GEO-SHIELD</span>
          <span>REGION · ACTIVATING</span>
        </div>

        <div className="relative mx-auto max-w-[1320px] px-5 md:px-12">
          {/* Eyebrow */}
          <div className="text-center mb-6">
            <div className="inline-flex items-center gap-2 text-[10px] font-bold tracking-[0.4em] uppercase text-white/55 border border-white/15 rounded-full px-4 py-2">
              <Target size={12} /> Activate Your Region
            </div>
          </div>

          {/* MAIN HEADLINE — clean centered */}
          <motion.h2
            {...fadeUp}
            className="text-center font-display text-white leading-[0.92] mx-auto max-w-[1100px]"
            style={{ fontSize: "clamp(40px, 7vw, 112px)" }}
          >
            "We can't ship<br />to your region."
          </motion.h2>
          <motion.p
            {...fadeUp}
            transition={{ duration: 0.6, delay: 0.05 }}
            className="text-center mt-6 text-white/55 italic text-[15px] md:text-[17px] tracking-wider"
          >
            Five words that broke a million fan hearts.
          </motion.p>

          {/* ROW 1 — THE PROBLEM (image left, copy right) */}
          <div className="mt-20 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            <motion.div
              {...fadeUp}
              transition={{ duration: 0.6, delay: 0.1 }}
              className="lg:col-span-5 flex justify-center"
            >
              <div className="relative">
                <div className="absolute -inset-6 bg-[#FF3B5C]/20 blur-3xl rounded-[40px]" aria-hidden />
                <img
                  src={A.checkoutBlocked}
                  alt="Checkout blocked: Due to licensing restrictions, the Warner Bros / Cartoon Network collection only ships to certain regions"
                  className="relative w-full max-w-[420px] rounded-[20px] shadow-[0_30px_60px_-15px_rgba(0,0,0,0.55)] border border-white/10"
                  draggable={false}
                />
                <div className="absolute -top-3 -left-3 bg-[#FF3B5C] text-white text-[10px] font-black tracking-[0.25em] uppercase px-3 py-1.5 rounded-full rotate-[-6deg] shadow-lg">
                  Heartbreak · Logged
                </div>
              </div>
            </motion.div>

            <motion.div
              {...fadeUp}
              transition={{ duration: 0.6, delay: 0.15 }}
              className="lg:col-span-7"
            >
              <div className="text-[10px] font-bold tracking-[0.4em] uppercase text-[#FF3B5C] mb-4">
                01 · The Problem
              </div>
              <h3
                className="font-display text-white leading-[0.95]"
                style={{ fontSize: "clamp(28px, 3.5vw, 48px)" }}
              >
                Region Blocked.<br />
                <span className="italic text-[#FF3B5C]">Fan Heartbroken.</span>
              </h3>
              <ul className="mt-7 space-y-3.5 text-[16px] md:text-[18px] text-white/80 leading-relaxed">
                <li className="flex items-start gap-3">
                  <span className="mt-2 w-1.5 h-1.5 rounded-full bg-[#FF3B5C] flex-shrink-0" />
                  They let you fall in love. Then said no.
                </li>
                <li className="flex items-start gap-3">
                  <span className="mt-2 w-1.5 h-1.5 rounded-full bg-[#FF3B5C] flex-shrink-0" />
                  You found it. You wanted it. Then checkout crushed you.
                </li>
                <li className="flex items-start gap-3">
                  <span className="mt-2 w-1.5 h-1.5 rounded-full bg-[#FF3B5C] flex-shrink-0" />
                  Just walls and licensing restrictions.
                </li>
              </ul>
            </motion.div>
          </div>

          {/* DIVIDER — "Not anymore." */}
          <motion.div
            {...fadeUp}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="my-20 md:my-28 flex items-center gap-6"
          >
            <span className="flex-1 h-px bg-white/15" />
            <span
              className="font-display italic text-white"
              style={{ fontSize: "clamp(34px, 5vw, 72px)" }}
            >
              Not anymore.
            </span>
            <span className="flex-1 h-px bg-white/15" />
          </motion.div>

          {/* ROW 2 — THE SOLUTION (copy left, shield right) */}
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            <motion.div
              {...fadeUp}
              transition={{ duration: 0.6, delay: 0.1 }}
              className="lg:col-span-7 order-2 lg:order-1"
            >
              <div className="text-[10px] font-bold tracking-[0.4em] uppercase text-[#FFD93D] mb-4">
                02 · The Solution
              </div>
              <h3
                className="font-display text-white leading-[0.95]"
                style={{ fontSize: "clamp(28px, 3.5vw, 48px)" }}
              >
                eGeez activates<br />
                <span className="italic text-[#FFD93D]">your region.</span>
              </h3>
              <p className="mt-7 text-[16px] md:text-[18px] text-white/85 leading-relaxed max-w-xl">
                Everything licensed under the sun — available for sale, legally and rightfully yours.
              </p>
              <div className="mt-4 inline-flex items-center gap-2 bg-[#FFD93D] text-black font-display italic text-[20px] md:text-[24px] px-5 py-2 rounded-full">
                <Radar size={16} /> Licensed Territory. Activated.
              </div>
              <ul className="mt-8 space-y-3.5 text-[15px] md:text-[17px] text-white/75 leading-relaxed">
                <li className="flex items-start gap-3">
                  <Check size={18} className="mt-1 text-[#FFD93D] flex-shrink-0" strokeWidth={3} />
                  Not hidden. Not blocked. Not "sorry, we can't ship there."
                </li>
                <li className="flex items-start gap-3">
                  <Check size={18} className="mt-1 text-[#FFD93D] flex-shrink-0" strokeWidth={3} />
                  Discover licensed drops from passionate licensees big platforms will never show you.
                </li>
              </ul>
            </motion.div>

            <motion.div
              {...fadeUp}
              transition={{ duration: 0.6, delay: 0.15 }}
              className="lg:col-span-5 flex justify-center order-1 lg:order-2"
            >
              <div className="relative">
                <div className="absolute -inset-6 bg-[#0041E6]/35 blur-3xl rounded-full" aria-hidden />
                <img
                  src={A.geoShield}
                  alt="eGeez GeoShield"
                  className="relative w-[260px] md:w-[340px] h-auto drop-shadow-[0_30px_60px_rgba(0,65,230,0.6)]"
                  draggable={false}
                />
              </div>
            </motion.div>
          </div>

          {/* CLOSING TAG */}
          <motion.div
            {...fadeUp}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="mt-24 text-center"
          >
            <div
              className="font-display italic text-white"
              style={{ fontSize: "clamp(28px, 3.5vw, 48px)" }}
            >
              This is your territory. Own it.
            </div>
            <div className="mt-6 inline-flex items-center gap-3 border border-white/25 text-white/85 font-mono text-[12px] tracking-[0.35em] uppercase px-6 py-3">
              <Radar size={14} /> Activate Your Licensed Region
            </div>
          </motion.div>
        </div>
      </section>
      {/* ============= 7. SMART IP DISCOVERY — abstract map + © pin ============= */}
      <section
        className="relative py-24 md:py-32 overflow-hidden"
        style={{
          background:
            "linear-gradient(160deg, #FFE5F0 0%, #FFC2DA 40%, #FF8FC5 100%)",
        }}
        data-testid="unlimited-section"
      >
        {/* subtle world-map-style dot grid */}
        <svg
          aria-hidden
          viewBox="0 0 1440 800"
          preserveAspectRatio="xMidYMid slice"
          className="absolute inset-0 w-full h-full opacity-30 pointer-events-none"
        >
          <defs>
            <pattern id="dotPat" x="0" y="0" width="22" height="22" patternUnits="userSpaceOnUse">
              <circle cx="2" cy="2" r="1.6" fill="#FFFFFF" />
            </pattern>
          </defs>
          <rect width="1440" height="800" fill="url(#dotPat)" />
        </svg>

        <div className="relative mx-auto max-w-[1400px] px-5 md:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
            {/* LEFT — Copy */}
            <div className="lg:col-span-6">
              <motion.div {...fadeUp}>
                <Eyebrow color="#FFFFFF">Smart IP Discovery</Eyebrow>
              </motion.div>
              <motion.h2
                {...fadeUp}
                className="mt-5 font-display italic text-white leading-[0.95] drop-shadow-[0_4px_24px_rgba(0,0,0,0.18)]"
                style={{ fontSize: "clamp(44px, 7vw, 96px)" }}
              >
                Unlimited Licensed
                <br />
                Products of your
                <br />
                <span className="text-black">favourite characters.</span>
              </motion.h2>
              <motion.p
                {...fadeUp}
                transition={{ duration: 0.6, delay: 0.1 }}
                className="mt-8 text-white text-[17px] md:text-[20px] leading-relaxed max-w-xl"
              >
                Access a vast selection of officially licensed products featuring your favourite characters — exclusive collections curated just for you, including pieces you never knew existed.
              </motion.p>
              <motion.div
                {...fadeUp}
                transition={{ duration: 0.6, delay: 0.15 }}
                className="mt-8 inline-flex items-center gap-2 bg-white text-[#D63384] rounded-full px-5 py-2.5 font-semibold text-[14px] shadow"
              >
                <Compass size={16} /> Region-aware · Curated for you
              </motion.div>
            </div>

            {/* RIGHT — Abstract map + © location pin */}
            <motion.div
              {...fadeUp}
              transition={{ duration: 0.8, delay: 0.1 }}
              className="lg:col-span-6 relative flex justify-center"
            >
              <div className="relative w-full max-w-[560px] aspect-square">
                {/* Abstract continents */}
                <svg
                  viewBox="0 0 400 400"
                  className="absolute inset-0 w-full h-full"
                  aria-hidden
                >
                  <defs>
                    <radialGradient id="mapGlow" cx="50%" cy="50%" r="50%">
                      <stop offset="0%" stopColor="#FFFFFF" stopOpacity="0.6" />
                      <stop offset="100%" stopColor="#FFFFFF" stopOpacity="0" />
                    </radialGradient>
                  </defs>
                  {/* glow base */}
                  <circle cx="200" cy="200" r="200" fill="url(#mapGlow)" />
                  {/* outer orbit */}
                  <circle cx="200" cy="200" r="180" stroke="#FFFFFF" strokeWidth="1" fill="none" strokeDasharray="4 8" opacity="0.5" />
                  <circle cx="200" cy="200" r="130" stroke="#FFFFFF" strokeWidth="1" fill="none" opacity="0.25" />

                  {/* Abstract continent blobs (purely decorative) */}
                  <g fill="#FFFFFF" opacity="0.9">
                    <path d="M70 150 Q 90 120 130 130 Q 160 140 155 170 Q 145 200 115 205 Q 80 200 70 180 Z" />
                    <path d="M195 90 Q 225 80 250 100 Q 265 115 255 140 Q 240 160 220 155 Q 195 145 195 120 Z" />
                    <path d="M260 200 Q 295 195 315 215 Q 325 240 310 260 Q 285 275 265 265 Q 250 240 260 220 Z" />
                    <path d="M140 240 Q 170 235 185 255 Q 190 280 170 295 Q 145 305 130 290 Q 125 265 135 250 Z" />
                    <path d="M225 285 Q 245 280 255 300 Q 255 320 235 325 Q 215 325 210 305 Z" />
                  </g>

                  {/* Scattered smaller product dots */}
                  <g fill="#FFD93D">
                    <circle cx="105" cy="165" r="4" />
                    <circle cx="225" cy="115" r="4" />
                    <circle cx="290" cy="235" r="4" />
                    <circle cx="160" cy="270" r="4" />
                    <circle cx="240" cy="305" r="4" />
                  </g>

                  {/* Connection lines from center pin */}
                  <g stroke="#FFFFFF" strokeWidth="1" strokeDasharray="3 5" opacity="0.6" fill="none">
                    <path d="M200 200 L 105 165" />
                    <path d="M200 200 L 225 115" />
                    <path d="M200 200 L 290 235" />
                    <path d="M200 200 L 160 270" />
                    <path d="M200 200 L 240 305" />
                  </g>
                </svg>

                {/* Center: giant location pin with © */}
                <motion.div
                  className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
                  animate={{ y: [-6, 6, -6] }}
                  transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
                >
                  <div className="relative">
                    <MapPin
                      size={180}
                      strokeWidth={1.4}
                      fill="#0041E6"
                      className="text-[#001F7A] drop-shadow-[0_30px_40px_rgba(0,0,0,0.35)]"
                    />
                    {/* © symbol inside the pin circle */}
                    <div className="absolute inset-0 flex items-start justify-center pt-[26px]">
                      <div className="w-[70px] h-[70px] rounded-full bg-white flex items-center justify-center shadow-inner">
                        <span
                          className="text-[#0041E6] font-black"
                          style={{ fontSize: 40, lineHeight: 1, fontFamily: "Inter" }}
                        >
                          ©
                        </span>
                      </div>
                    </div>
                    {/* pulse rings */}
                    <div className="absolute left-1/2 -translate-x-1/2 top-full mt-2 w-[90px] h-[26px]">
                      <div className="absolute inset-0 rounded-[50%] bg-black/20 blur-md" />
                    </div>
                  </div>
                  {/* COPYRIGHTED LABEL */}
                  <div className="mt-3 text-center">
                    <div className="inline-block bg-white text-[#0041E6] text-[10px] font-black tracking-[0.25em] uppercase px-3 py-1 rounded-full shadow-md">
                      © Licensed · Your Region
                    </div>
                  </div>
                </motion.div>

                {/* floating product mini-badges */}
                {[
                  { t: "Garfield", x: "18%", y: "32%", rot: -6 },
                  { t: "Scooby-Doo", x: "68%", y: "22%", rot: 8 },
                  { t: "Stranger Things", x: "78%", y: "60%", rot: -4 },
                  { t: "Hulk Hogan", x: "22%", y: "66%", rot: 5 },
                ].map((b, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, scale: 0.6 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5, delay: 0.3 + i * 0.1 }}
                    className="absolute bg-white rounded-full px-3 py-1.5 text-[11px] font-bold text-[#0041E6] shadow-md"
                    style={{
                      left: b.x,
                      top: b.y,
                      transform: `translate(-50%,-50%) rotate(${b.rot}deg)`,
                    }}
                  >
                    {b.t}
                  </motion.div>
                ))}
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* ============= 8. VERIFICATION ============= */}
      <section
        className="relative py-24 md:py-32 bg-white overflow-hidden"
        data-testid="verification-section"
      >
        {/* soft brand accents in corners */}
        <div className="absolute inset-0 -z-0 pointer-events-none">
          <div className="absolute -top-32 -left-32 w-[500px] h-[500px] rounded-full bg-[#0041E6]/8 blur-3xl" />
          <div className="absolute -bottom-32 -right-32 w-[500px] h-[500px] rounded-full bg-[#FFD93D]/15 blur-3xl" />
        </div>

        <div className="mx-auto max-w-[1300px] px-5 md:px-12 relative z-10">
          <motion.div {...fadeUp} className="text-center max-w-3xl mx-auto">
            <Eyebrow>Trust layer</Eyebrow>
            <h2 className="mt-5 font-display text-black leading-[0.92]" style={{ fontSize: "clamp(42px, 6.5vw, 96px)" }}>
              Verification &amp;{" "}
              <span className="text-[#0041E6] italic">counterfeit.</span>
            </h2>
            <p className="mt-7 text-[18px] md:text-[20px] text-black/75 leading-relaxed">
              Peace of mind, built in. Every licensee on eGeez is fully verified. Every product is trademarked. No counterfeits — just trusted, official merchandise.
            </p>
          </motion.div>

          {/* Two-column content card with single big checkmark */}
          <motion.div
            {...fadeUp}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="mt-14 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center"
          >
            {/* Big single blue checkmark */}
            <div className="lg:col-span-4 flex justify-center">
              <div className="relative">
                <div className="absolute inset-0 rounded-full bg-[#0041E6]/20 blur-3xl scale-110" />
                <div
                  className="relative w-[260px] h-[260px] md:w-[320px] md:h-[320px] rounded-full flex items-center justify-center animate-floatY"
                  style={{
                    background:
                      "radial-gradient(circle at 30% 25%, #2856F0 0%, #0041E6 55%, #0033B8 100%)",
                    boxShadow:
                      "0 30px 60px -15px rgba(0,65,230,0.55), inset 0 -10px 30px rgba(0,0,0,0.18), inset 0 8px 20px rgba(255,255,255,0.18)",
                  }}
                >
                  <Check
                    size={140}
                    strokeWidth={3}
                    className="text-white drop-shadow-md"
                    style={{ strokeLinecap: "round", strokeLinejoin: "round" }}
                  />
                </div>
                <div className="absolute -top-3 right-6 bg-[#0041E6] text-white text-[10px] font-black tracking-[0.25em] px-3 py-1.5 rounded-full uppercase rotate-[-8deg] shadow-lg">
                  Verified
                </div>
              </div>
            </div>

            {/* Two stacked info cards */}
            <div className="lg:col-span-8 space-y-5">
              <div className="rounded-[24px] border-2 border-[#0041E6]/15 bg-[#FAFAFA] p-7 md:p-8">
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-10 h-10 rounded-full bg-[#0041E6] text-white font-black flex items-center justify-center text-[13px]">
                    01
                  </div>
                  <div>
                    <h3 className="font-display text-[24px] md:text-[28px] text-black leading-tight">
                      Beyond surface checks
                    </h3>
                    <p className="mt-2 text-[15px] md:text-[16px] text-black/75 leading-relaxed">
                      eGeez goes beyond checking if the vendor just has the studio logo (Disney<sup>®</sup> icon), a barcode, or trademark clause on its packaging.
                    </p>
                  </div>
                </div>
              </div>

              <div className="rounded-[24px] bg-[#0041E6] p-7 md:p-8 text-white">
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-10 h-10 rounded-full bg-[#FFD93D] text-[#0041E6] font-black flex items-center justify-center text-[13px]">
                    02
                  </div>
                  <div>
                    <h3 className="font-display text-[24px] md:text-[28px] leading-tight">
                      The <span className="italic">ePIN</span> safety net
                    </h3>
                    <p className="mt-2 text-[15px] md:text-[16px] text-white/90 leading-relaxed">
                      The ePIN is a unique code that verifies the identity of an official licensee (Human / AI verification) and ensures secure access to the eLicensee platform. It is one of our safety measures to protect the licensing industry — and the fans — from counterfeits.
                    </p>
                  </div>
                </div>
              </div>

              {/* Live verification badge — renamed */}
              <div className="inline-flex items-center gap-3 text-sm font-semibold text-[#0041E6] bg-[#0041E6]/10 rounded-full px-5 py-2.5 border border-[#0041E6]/15">
                <span className="w-2 h-2 rounded-full bg-[#0041E6] animate-pulse" />
                eSmart Licensee Gateway Verification
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* ============= 9. FOUNDER STORY — Licensing Wizard ============= */}
      <section className="relative py-24 md:py-32 bg-[#FAFAFA] overflow-hidden" data-testid="founder-section">
        <div className="absolute inset-0 -z-10 pointer-events-none">
          <div className="absolute -top-32 -right-40 w-[600px] h-[600px] rounded-full bg-[#FFD93D]/20 blur-3xl" />
          <div className="absolute -bottom-32 -left-40 w-[500px] h-[500px] rounded-full bg-[#0041E6]/8 blur-3xl" />
        </div>

        <div className="mx-auto max-w-[1400px] px-5 md:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
            {/* LEFT — Photo collage */}
            <motion.div
              {...fadeUp}
              className="lg:col-span-6 relative min-h-[520px] md:min-h-[640px]"
            >
              {/* Big featured photo — with Garfield mascot */}
              <motion.div
                initial={{ opacity: 0, y: 30, rotate: -4 }}
                whileInView={{ opacity: 1, y: 0, rotate: -4 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
                className="absolute top-0 left-4 md:left-10 w-[58%] md:w-[62%] rounded-[28px] overflow-hidden shadow-2xl border-[6px] border-white z-10"
              >
                <img
                  src={A.founderMascot}
                  alt="Nathen Mazri with Garfield"
                  className="w-full h-auto block"
                />
                <div className="absolute bottom-3 left-3 bg-[#0041E6] text-white text-[10px] font-black tracking-[0.25em] px-3 py-1 rounded-full uppercase">
                  Founder · Nathen
                </div>
              </motion.div>

              {/* Top-right — Jim Davis photo */}
              <motion.div
                initial={{ opacity: 0, y: 30, rotate: 6 }}
                whileInView={{ opacity: 1, y: 0, rotate: 6 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
                className="absolute top-10 right-0 w-[44%] md:w-[42%] rounded-[24px] overflow-hidden shadow-xl border-[5px] border-white z-20"
              >
                <img
                  src={A.founderJimDavis}
                  alt="With Jim Davis, creator of Garfield"
                  className="w-full h-auto block"
                />
                <div className="absolute bottom-2 left-2 bg-[#FFD93D] text-[#0041E6] text-[9px] font-black tracking-[0.25em] px-2 py-0.5 rounded-full uppercase">
                  With Jim Davis
                </div>
              </motion.div>

              {/* Bottom — orange portrait */}
              <motion.div
                initial={{ opacity: 0, y: 30, rotate: 3 }}
                whileInView={{ opacity: 1, y: 0, rotate: 3 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7, delay: 0.3, ease: [0.16, 1, 0.3, 1] }}
                className="absolute bottom-0 right-10 md:right-20 w-[38%] md:w-[36%] rounded-[20px] overflow-hidden shadow-xl border-[5px] border-white z-30"
              >
                <img
                  src={A.founderGarfield}
                  alt="The licensing wizard"
                  className="w-full h-auto block"
                />
              </motion.div>

              {/* Sticker badge */}
              <motion.div
                initial={{ opacity: 0, scale: 0.6, rotate: -18 }}
                whileInView={{ opacity: 1, scale: 1, rotate: -12 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.45 }}
                className="absolute bottom-6 left-0 md:left-4 z-40 bg-[#FFD93D] text-[#0041E6] font-display text-[14px] md:text-[16px] px-4 py-3 rounded-2xl shadow-xl text-center leading-tight"
                style={{ width: 140 }}
              >
                World's<br />youngest<br />Garfield<br />licensee
              </motion.div>
            </motion.div>

            {/* RIGHT — Copy */}
            <motion.div {...fadeUp} transition={{ duration: 0.6, delay: 0.1 }} className="lg:col-span-6">
              <Eyebrow>The licensing wizard</Eyebrow>
              <h2
                className="mt-5 font-display text-black leading-[0.92]"
                style={{ fontSize: "clamp(40px, 6vw, 88px)" }}
              >
                Built by a fan.<br />
                For every fan.<br />
                <span className="text-[#0041E6] italic">Made by a licensee.</span>
                <br />
                For every licensee.
              </h2>

              <div className="mt-8 space-y-5 text-[16px] md:text-[18px] text-black/80 leading-relaxed max-w-xl">
                <p>
                  <span className="font-semibold text-black">Nathen Mazri</span> didn't just love fandoms — he lived inside one. As the world's youngest Garfield licensee and founder of <em>GarfieldEATS</em> and <em>Scooby-Doo EATS</em>, he felt the checkout heartbreak, the counterfeit chaos, and the invisible walls blocking fans from what was rightfully theirs.
                </p>
                <p>
                  So he built the fix — after years of silent tears.
                </p>
                <p className="text-black">
                  When the creator of Garfield, <span className="font-semibold">Jim Davis</span>, <span className="font-semibold">Hulk Hogan</span>, Hollywood studio executives, licensees and fans worldwide all say you're onto something — you build it.
                </p>
              </div>

              <div className="mt-10 flex flex-wrap items-center gap-4">
                <Link
                  to="/about-egeez"
                  data-testid="visit-about-egeez-link"
                  className="group inline-flex items-center gap-3 bg-[#0041E6] hover:bg-[#0033B8] text-white font-semibold text-[16px] rounded-full pl-7 pr-2 h-[54px] transition shadow-[0_14px_30px_-12px_rgba(0,65,230,0.5)]"
                >
                  <span className="underline decoration-[#FFD93D] decoration-2 underline-offset-4">
                    Visit About eGeez
                  </span>
                  <span className="w-[40px] h-[40px] rounded-full bg-white text-[#0041E6] flex items-center justify-center transition-transform group-hover:rotate-45">
                    <ArrowUpRight size={18} />
                  </span>
                </Link>
                <a
                  href={T.joinWaitlist}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[15px] font-semibold text-black hover:text-[#0041E6] transition inline-flex items-center gap-2"
                >
                  Join the Waitlist <ArrowUpRight size={14} />
                </a>
              </div>
            </motion.div>
          </div>
        </div>
      </section>


      {/* ============= 11. PREMIERE DROP — split: white (logo) + yellow (Fanvestor) — PURE CSS/SVG, deploy-safe ============= */}
      <section className="relative py-24 md:py-32 bg-[#FAFAFA]" id="premiere-drop-fans" data-testid="premiere-drop-fans">
        <div className="mx-auto max-w-[1300px] px-5 md:px-12 space-y-6">
          {/* TOP HALF — WHITE bg with pure-CSS Premiere Drop logo */}
          <motion.div
            {...fadeUp}
            className="relative rounded-[40px] overflow-hidden p-10 md:p-16 text-black bg-white border border-black/8 shadow-[0_30px_80px_-30px_rgba(0,0,0,0.18)]"
          >
            <div className="absolute -top-32 -right-40 w-[600px] h-[600px] rounded-full bg-[#FFD400]/15 blur-3xl pointer-events-none" />

            <div className="relative z-10 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
              {/* LEFT — Copy */}
              <div className="lg:col-span-7">
                <div className="inline-flex items-center gap-2 text-[11px] md:text-[12px] font-bold tracking-[0.28em] uppercase text-[#0041E6] mb-5">
                  <span className="inline-block w-6 h-px bg-[#0041E6]" />
                  Ready?
                </div>

                {/* Premiere Drop logo — same image as Footer + For Licensees, deploy-proven */}
                <img
                  src={A.premiereLogo}
                  alt="Premiere Drop"
                  className="h-14 md:h-20 w-auto mb-6"
                  draggable={false}
                  data-testid="premiere-drop-logo"
                />

                <h2
                  className="font-display text-black leading-[0.92]"
                  style={{ fontSize: "clamp(40px, 6.5vw, 88px)" }}
                >
                  You're not late.<br />
                  <span className="italic text-[#0041E6]">You're first.</span>
                </h2>
                <p className="mt-6 text-[16px] md:text-[18px] text-black/80 leading-relaxed max-w-xl">
                  Premiere Drop works like a movie hitting theatres before streaming — except it's <em>your merch</em>. Freshly approved by the licensor. Not yet in stores. Not yet everywhere.
                </p>
                <p className="mt-3 text-[16px] md:text-[18px] text-black font-semibold leading-relaxed max-w-xl">
                  Just on eGeez. Just for you. Right now.
                </p>
                <p className="mt-3 text-[15px] md:text-[16px] text-black/70 leading-relaxed max-w-xl">
                  Check the expected ship date and claim yours before the world catches up.
                </p>

                <div className="mt-8 flex flex-wrap items-center gap-4">
                  <a
                    href={T.joinWaitlist}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group inline-flex items-center gap-3 bg-[#0041E6] hover:bg-[#0033B8] text-white font-bold text-[17px] rounded-full pl-7 pr-2 h-[58px] transition shadow-[0_14px_30px_-12px_rgba(0,65,230,0.5)]"
                    data-testid="premiere-drop-cta-btn"
                  >
                    Join the Waitlist
                    <span className="w-[42px] h-[42px] rounded-full bg-white text-[#0041E6] flex items-center justify-center transition-transform group-hover:rotate-45">
                      <ArrowUpRight size={18} />
                    </span>
                  </a>
                  <AppStoreBadges variant="dark" size="sm" />
                </div>
              </div>

              {/* RIGHT — Leaderboard phone w/ animated callout (same as For Licensees, deploy-proven image) */}
              <motion.div
                initial={{ opacity: 0, scale: 0.92, y: 20 }}
                whileInView={{ opacity: 1, scale: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
                className="lg:col-span-5 flex justify-center"
              >
                <div className="group relative cursor-pointer" tabIndex={0} data-testid="leaderboard-phone">
                  <img
                    src={A.premiereLeaderboard}
                    alt="Premiere Drop leaderboard"
                    className="w-full max-w-[420px] rounded-[28px] shadow-[0_30px_80px_-20px_rgba(0,0,0,0.35)] transition-transform duration-500 group-hover:scale-[1.02]"
                    draggable={false}
                  />
                  <div className="absolute -top-4 -left-4 bg-black text-[#FFD400] text-[10px] font-black tracking-[0.25em] uppercase px-3 py-1.5 rounded-full rotate-[-6deg] shadow-lg">
                    ★ Leaderboard Live
                  </div>

                  <div
                    className="absolute -right-6 top-12 md:-right-12 md:top-16 z-20 origin-bottom-left opacity-0 -translate-y-3 scale-90 rotate-[-6deg] group-hover:opacity-100 group-hover:translate-y-0 group-hover:scale-100 group-hover:rotate-[-3deg] group-focus-within:opacity-100 group-focus-within:translate-y-0 group-focus-within:scale-100 transition-all duration-500"
                    aria-hidden
                  >
                    <div className="relative bg-[#FFD400] text-black px-5 py-3 rounded-2xl shadow-[0_18px_30px_-12px_rgba(0,0,0,0.45)] border-2 border-black">
                      <div className="flex items-center gap-2">
                        <span className="text-[20px] leading-none">★</span>
                        <div className="font-display italic text-[20px] md:text-[24px] leading-tight">
                          I Geez&apos;d it<br />
                          <span className="text-[#0041E6]">Third!</span>
                        </div>
                      </div>
                      <div className="absolute -bottom-2 left-6 w-4 h-4 bg-[#FFD400] border-r-2 border-b-2 border-black rotate-45" />
                    </div>
                    <Sparkles size={14} className="absolute -top-3 -right-3 text-[#0041E6] animate-pulse" />
                    <Sparkles size={12} className="absolute -bottom-2 -right-2 text-[#FFD400]" />
                  </div>

                  <div className="absolute left-1/2 -translate-x-1/2 -bottom-4 bg-black text-white text-[10px] font-bold tracking-[0.25em] uppercase px-3 py-1.5 rounded-full opacity-80 group-hover:opacity-0 transition-opacity">
                    Tap to brag
                  </div>
                </div>
              </motion.div>
            </div>
          </motion.div>

          {/* BOTTOM HALF — YELLOW bg (Fanvestor) */}
          <motion.div
            {...fadeUp}
            transition={{ duration: 0.6, delay: 0.05 }}
            className="relative rounded-[40px] overflow-hidden p-10 md:p-16"
            style={{
              background:
                "radial-gradient(ellipse at top right, #FFE680 0%, #FFD400 35%, #F5B800 80%)",
            }}
          >
            {/* Star confetti */}
            <svg
              aria-hidden
              className="absolute inset-0 w-full h-full pointer-events-none opacity-20"
              viewBox="0 0 1200 600"
              preserveAspectRatio="xMidYMid slice"
            >
              {[
                [120, 80, 12], [340, 140, 8], [560, 90, 10], [820, 160, 14],
                [1080, 110, 9], [180, 320, 7], [420, 380, 11], [950, 360, 8],
                [1140, 480, 10], [70, 540, 13], [310, 520, 9], [580, 490, 11],
              ].map(([x, y, r], i) => (
                <g key={i} transform={`translate(${x} ${y})`}>
                  <path
                    d={`M0,-${r} L${r * 0.3},-${r * 0.3} L${r},0 L${r * 0.3},${r * 0.3} L0,${r} L-${r * 0.3},${r * 0.3} L-${r},0 L-${r * 0.3},-${r * 0.3} Z`}
                    fill="#000000"
                  />
                </g>
              ))}
            </svg>

            <div className="relative z-10">
              <div className="inline-flex items-center gap-2 text-[11px] font-bold tracking-[0.28em] uppercase text-[#0041E6] mb-4">
                <span className="inline-block w-6 h-px bg-[#0041E6]" />
                Create hype early
              </div>
              <h3
                className="font-display text-black leading-[0.95] max-w-4xl"
                style={{ fontSize: "clamp(32px, 4.5vw, 64px)" }}
              >
                You're not just a fan.<br />
                <span className="italic text-[#0041E6]">You're a Fanvestor.</span>
              </h3>
              <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-5 max-w-5xl">
                {[
                  { t: "Pre-order before drop", b: "Pre-order before the global release drops." },
                  { t: "Climb the leaderboard", b: "Score limited collectibles nobody else can get." },
                  { t: "Show the world", b: "Screenshot your ranking and prove you were first." },
                ].map((c, i) => (
                  <div key={i} className="bg-white rounded-[20px] p-5 border border-black/5 shadow-sm">
                    <div className="text-[#0041E6] text-[20px] mb-2" aria-hidden>★</div>
                    <div className="font-semibold text-black text-[15px]">{c.t}</div>
                    <div className="text-[14px] text-black/70 mt-1 leading-snug">{c.b}</div>
                  </div>
                ))}
              </div>
              <p className="mt-10 font-display italic text-black text-[22px] md:text-[28px] leading-snug max-w-2xl">
                The early fan gets the drop.<br />
                <span className="text-black/55">Everyone else gets the restock.</span>
              </p>
            </div>
          </motion.div>
        </div>
      </section>
      {/* ============= 10. eGEEZ ADVENTURES — pure SVG/CSS, deploy-safe (only logo as image) ============= */}
      <section
        className="relative py-24 md:py-32 bg-[#FAFAFA]"
        id="egeez-adventures"
        data-testid="adventures-section"
      >
        <div className="mx-auto max-w-[1400px] px-5 md:px-12">
          <motion.div
            {...fadeUp}
            className="relative rounded-[40px] overflow-hidden grid grid-cols-1 md:grid-cols-2 items-stretch min-h-[680px]"
            style={{ backgroundColor: "#FF9A1F" }}
          >
            {/* CSS cloud horizon at the bottom */}
            <svg
              aria-hidden
              viewBox="0 0 800 220"
              preserveAspectRatio="none"
              className="absolute bottom-0 left-0 right-0 w-full h-[160px] pointer-events-none"
            >
              <path
                d="M0 180 Q60 110 130 140 Q200 90 280 130 Q360 80 440 130 Q520 90 600 140 Q680 100 760 140 L800 160 L800 220 L0 220 Z"
                fill="#FFB347"
                opacity="0.85"
              />
              <path
                d="M0 200 Q80 150 180 175 Q260 140 360 170 Q440 145 540 175 Q640 145 740 175 L800 190 L800 220 L0 220 Z"
                fill="#FFCB7A"
              />
            </svg>

            {/* ============ LEFT — Pure SVG/CSS visual stage ============ */}
            <div className="relative h-[520px] md:h-[680px] overflow-hidden">
              {/* Colorful confetti — flying multi-color particles */}
              {Array.from({ length: 32 }).map((_, i) => {
                const palette = ["#FFD400", "#FFFFFF", "#FF4DA6", "#22D3EE", "#A78BFA", "#0041E6", "#7CB342"];
                const c = palette[i % palette.length];
                const left = (i * 41) % 100;
                const top = (i * 67) % 100;
                const dur = 3.5 + (i % 5);
                const delay = (i % 8) * 0.25;
                const isStar = i % 4 === 0;
                const size = isStar ? 8 : 4 + (i % 3) * 2;
                return (
                  <motion.span
                    key={`confetti-${i}`}
                    aria-hidden
                    className="absolute pointer-events-none"
                    style={{
                      left: `${left}%`,
                      top: `${top}%`,
                      width: size,
                      height: size,
                      background: c,
                      borderRadius: isStar ? "0%" : "50%",
                      transform: `rotate(${i * 17}deg)`,
                      boxShadow: `0 0 6px ${c}66`,
                    }}
                    animate={{
                      y: ["0%", "-180%"],
                      x: [`0%`, `${(i % 2 === 0 ? 1 : -1) * (10 + (i % 5) * 4)}%`],
                      rotate: [0, 360],
                      opacity: [0, 1, 1, 0],
                    }}
                    transition={{
                      duration: dur,
                      delay,
                      repeat: Infinity,
                      ease: "linear",
                    }}
                  />
                );
              })}

              {/* Floating sparkles */}
              {[
                { x: "14%", y: "22%", d: 0, c: "#FFFFFF" },
                { x: "78%", y: "14%", d: 0.8, c: "#FFD400" },
                { x: "10%", y: "76%", d: 1.4, c: "#FF4DA6" },
                { x: "84%", y: "62%", d: 0.4, c: "#22D3EE" },
              ].map((s, i) => (
                <motion.span
                  key={`spk-${i}`}
                  aria-hidden
                  className="absolute"
                  style={{ left: s.x, top: s.y, color: s.c }}
                  animate={{
                    scale: [0.6, 1.2, 0.6],
                    opacity: [0.3, 1, 0.3],
                    rotate: [0, 180, 360],
                  }}
                  transition={{
                    duration: 4,
                    delay: s.d,
                    repeat: Infinity,
                    ease: "easeInOut",
                  }}
                >
                  <Sparkles size={20} />
                </motion.span>
              ))}

              {/* COMING SOON — playful tilted ribbon stamp, top-right corner — wobble + scale */}
              <motion.div
                initial={{ opacity: 0, scale: 0.5, rotate: 24 }}
                whileInView={{ opacity: 1, scale: 1, rotate: 16 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7, delay: 0.3, ease: [0.16, 1, 0.3, 1] }}
                animate={{
                  rotate: [16, 22, 10, 18, 16],
                  scale: [1, 1.08, 0.96, 1.04, 1],
                  y: [0, -6, 0, -3, 0],
                }}
                style={{ transition: "none" }}
                className="absolute top-6 right-6 md:top-10 md:right-10 z-30"
                data-testid="adv-coming-soon-stamp"
              >
                <div className="relative">
                  {/* Yellow halo */}
                  <div className="absolute -inset-3 bg-[#FFD400]/40 blur-2xl rounded-full" aria-hidden />
                  {/* Stamp */}
                  <div
                    className="relative bg-[#1A1A1A] text-[#FFD400] font-black text-[12px] md:text-[14px] tracking-[0.3em] px-5 py-2.5 border-2 border-[#FFD400] shadow-2xl"
                    style={{
                      borderRadius: "4px",
                      filter: "drop-shadow(0 8px 16px rgba(0,0,0,0.35))",
                    }}
                  >
                    <span className="block leading-none">COMING</span>
                    <span className="block leading-none mt-0.5 text-[10px] md:text-[11px] tracking-[0.45em]">SOON</span>
                  </div>
                  {/* Corner stars */}
                  <span className="absolute -top-2 -left-2 text-[#FFD400] text-[16px]" aria-hidden>★</span>
                  <span className="absolute -bottom-2 -right-2 text-[#FFD400] text-[14px]" aria-hidden>★</span>
                </div>
              </motion.div>

              {/* TICKET 1 — Stranger Things (top-left) — sway + bob + tilt */}
              <motion.div
                initial={{ opacity: 0, x: -40, rotate: -30 }}
                whileInView={{ opacity: 1, x: 0, rotate: -22 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: 0.4, ease: [0.16, 1, 0.3, 1] }}
                animate={{
                  y: [0, -16, 0, -8, 0],
                  x: [0, 4, 0, -4, 0],
                  rotate: [-22, -16, -24, -18, -22],
                }}
                style={{ transition: "none" }}
                className="absolute top-[18%] left-[4%] md:left-[6%] z-[1] w-[44%] md:w-[42%] max-w-[280px]"
                data-testid="adv-ticket-stranger"
              >
                <Ticket title="Stranger Things" subtitle="Immersive Experience" date="08·15·2026" seat="ROW 7" color="#0041E6" accent="#FFD400" />
              </motion.div>

              {/* TICKET 2 — Friends (mid-right) — opposite sway */}
              <motion.div
                initial={{ opacity: 0, x: 40, rotate: 30 }}
                whileInView={{ opacity: 1, x: 0, rotate: 18 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: 0.55, ease: [0.16, 1, 0.3, 1] }}
                animate={{
                  y: [0, -18, 0, -6, 0],
                  x: [0, -5, 0, 5, 0],
                  rotate: [18, 24, 14, 20, 18],
                }}
                style={{ transition: "none" }}
                className="absolute bottom-[14%] right-[3%] md:right-[5%] z-[1] w-[44%] md:w-[42%] max-w-[280px]"
                data-testid="adv-ticket-friends"
              >
                <Ticket title="Friends" subtitle="Immersive Experience" date="11·02·2026" seat="ROW 12" color="#FF4DA6" accent="#FFFFFF" />
              </motion.div>

              {/* BOOKING CARD 1 — Hawkins Lab — pulse + bob */}
              <motion.div
                initial={{ opacity: 0, scale: 0.6, rotate: -10 }}
                whileInView={{ opacity: 1, scale: 1, rotate: -6 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.7 }}
                animate={{
                  y: [0, -14, 0, -7, 0],
                  rotate: [-6, -2, -10, -4, -6],
                  scale: [1, 1.03, 1, 1.01, 1],
                }}
                style={{ transition: "none" }}
                className="absolute top-[8%] right-[10%] z-[2] w-[32%] md:w-[28%] max-w-[190px] bg-white rounded-2xl shadow-2xl p-3 ring-1 ring-black/5"
                data-testid="adv-card-hawkins"
              >
                <div className="aspect-[4/3] rounded-xl bg-gradient-to-br from-[#0041E6] to-[#7B2FF7] flex items-center justify-center relative overflow-hidden mb-2">
                  <motion.div
                    className="absolute inset-0 opacity-30"
                    style={{ backgroundImage: "radial-gradient(circle at 30% 30%, #FFD400 0%, transparent 40%)" }}
                    animate={{ opacity: [0.2, 0.5, 0.2] }}
                    transition={{ duration: 2.4, repeat: Infinity, ease: "easeInOut" }}
                  />
                  <span className="font-display text-white text-[20px] italic z-10">Hawkins Lab</span>
                </div>
                <div className="text-[10px] font-black tracking-widest uppercase text-[#0041E6]">★ Themed Hotel</div>
                <div className="font-bold text-[12px] text-black mt-0.5">From $189/night</div>
              </motion.div>

              {/* BOOKING CARD 2 — Central Perk — rock + bob */}
              <motion.div
                initial={{ opacity: 0, scale: 0.6, rotate: 12 }}
                whileInView={{ opacity: 1, scale: 1, rotate: 8 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.85 }}
                animate={{
                  y: [0, -16, 0, -5, 0],
                  rotate: [8, 14, 4, 10, 8],
                  scale: [1, 1.04, 1, 1.02, 1],
                }}
                style={{ transition: "none" }}
                className="absolute bottom-[28%] left-[8%] z-[2] w-[32%] md:w-[28%] max-w-[190px] bg-white rounded-2xl shadow-2xl p-3 ring-1 ring-black/5"
                data-testid="adv-card-perk"
              >
                <motion.div
                  className="aspect-[4/3] rounded-xl bg-gradient-to-br from-[#FF6B35] to-[#FFD400] flex items-center justify-center relative overflow-hidden mb-2"
                  animate={{
                    background: [
                      "linear-gradient(135deg, #FF6B35 0%, #FFD400 100%)",
                      "linear-gradient(135deg, #FF8C42 0%, #FFAA00 100%)",
                      "linear-gradient(135deg, #FF6B35 0%, #FFD400 100%)",
                    ],
                  }}
                  transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
                >
                  <span className="font-display text-white text-[20px] italic z-10 drop-shadow-md">Central Perk</span>
                </motion.div>
                <div className="text-[10px] font-black tracking-widest uppercase text-[#FF6B35]">☕ Pop-Up</div>
                <div className="font-bold text-[12px] text-black mt-0.5">From $24/visit</div>
              </motion.div>

              {/* CENTRAL PHONE MOCK — bigger, animated with sway + pulse */}
              <motion.div
                initial={{ opacity: 0, y: 30, scale: 0.9 }}
                whileInView={{ opacity: 1, y: 0, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.9, delay: 0.3, ease: [0.16, 1, 0.3, 1] }}
                animate={{
                  y: [0, -18, 0, -10, 0],
                  rotate: [0, 1.5, 0, -1.5, 0],
                }}
                style={{ transition: "none" }}
                className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-[44%] z-[5]"
                data-testid="adv-phone-mock"
              >
                {/* Pulsing yellow halo behind phone */}
                <motion.div
                  className="absolute -inset-12 bg-[#FFD400]/30 blur-3xl rounded-full pointer-events-none"
                  aria-hidden
                  animate={{
                    scale: [1, 1.15, 1],
                    opacity: [0.3, 0.6, 0.3],
                  }}
                  transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
                />

                <div
                  className="relative h-[360px] md:h-[500px] aspect-[9/19] rounded-[40px] p-[6px] shadow-[0_40px_90px_-20px_rgba(0,0,0,0.6)]"
                  style={{ background: "linear-gradient(160deg, #1a1a22 0%, #0b0b10 100%)" }}
                >
                  {/* Notch */}
                  <div className="absolute top-2.5 left-1/2 -translate-x-1/2 z-20 w-20 md:w-24 h-3.5 md:h-5 bg-black rounded-full" aria-hidden />

                  {/* Screen */}
                  <div className="relative w-full h-full rounded-[34px] overflow-hidden bg-gradient-to-b from-[#FFF6E5] to-[#FFE2B0]">
                    <div className="flex justify-between items-center px-4 pt-3 text-[9px] md:text-[11px] font-bold text-black/70">
                      <span>9:41</span>
                      <span>•••</span>
                    </div>

                    <div className="px-4 mt-2">
                      <div className="text-[9px] md:text-[11px] font-black tracking-[0.25em] uppercase text-[#FF8C42]">
                        eGeez Adventures
                      </div>
                      <div className="font-display text-black text-[16px] md:text-[22px] leading-tight mt-0.5">
                        Book your fandom.
                      </div>
                    </div>

                    <div className="px-3 mt-3 space-y-2">
                      {[
                        { t: "Stranger Things", s: "Immersive · NYC", c: "#0041E6" },
                        { t: "Friends Pop-Up", s: "Themed Café · LA", c: "#FF4DA6" },
                        { t: "Garfield Hotel", s: "Themed Stay", c: "#FF8C42" },
                        { t: "Batman Bunker", s: "VR Experience", c: "#1A1A1A" },
                      ].map((row, i) => (
                        <motion.div
                          key={i}
                          initial={{ opacity: 0, x: -10 }}
                          animate={{ opacity: 1, x: 0 }}
                          transition={{ delay: 0.6 + i * 0.2, duration: 0.4 }}
                          className="bg-white rounded-lg px-2.5 py-2 flex items-center gap-2 shadow-sm"
                        >
                          <div
                            className="w-6 h-6 md:w-7 md:h-7 rounded-md flex items-center justify-center text-white font-black text-[9px] md:text-[11px] flex-shrink-0"
                            style={{ background: row.c }}
                          >
                            ★
                          </div>
                          <div className="flex-1 min-w-0">
                            <div className="text-[10px] md:text-[12px] font-bold text-black truncate">{row.t}</div>
                            <div className="text-[8px] md:text-[10px] text-black/55 truncate">{row.s}</div>
                          </div>
                          <div className="text-[9px] md:text-[11px] font-black text-[#0041E6] flex-shrink-0">→</div>
                        </motion.div>
                      ))}
                    </div>

                    <motion.div
                      animate={{ scale: [1, 1.04, 1] }}
                      transition={{ duration: 1.6, repeat: Infinity, ease: "easeInOut" }}
                      className="absolute left-3 right-3 bottom-3 bg-[#1A1A1A] text-white text-[10px] md:text-[12px] font-black tracking-wider uppercase py-2.5 rounded-md text-center shadow-md"
                    >
                      Book Now
                    </motion.div>
                  </div>
                </div>
              </motion.div>
            </div>

            {/* ============ RIGHT — copy ============ */}
            <div className="relative p-10 md:p-16 text-white flex flex-col justify-center z-10">
              <Eyebrow color="#FFFFFF">Drop 01 · Experiences</Eyebrow>
              {/* Official eGeez Adventures logo — original with white square BG (per user request) */}
              <motion.img
                src={A.adventuresOfficialLogo}
                alt="eGeez Adventures"
                initial={{ opacity: 0, y: 10, rotate: -3 }}
                whileInView={{ opacity: 1, y: 0, rotate: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7, delay: 0.1 }}
                className="w-[260px] md:w-[400px] h-auto mt-4 self-start drop-shadow-[0_8px_20px_rgba(0,0,0,0.18)] rounded-md"
                draggable={false}
                data-testid="adventures-official-logo"
              />
              <p className="mt-8 text-[19px] md:text-[22px] leading-relaxed max-w-md">
                Book unique official licensed experiences and themed hotels — curated for fans, bookable directly inside eGeez.
              </p>
              <a
                href={T.joinWaitlist}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-8 inline-flex items-center gap-2 bg-black text-white font-semibold rounded-full px-7 py-4 hover:bg-white hover:text-black transition self-start"
                data-testid="adventures-cta"
              >
                Get early access
                <ArrowUpRight size={18} />
              </a>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
